import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { LocationGroupRepository } from "../../repositories/location-group.repository";
import { RenameLocationGroup } from "../../domain/requests/location-group/rename-location-group";
import { BaseResponse } from "planning-portal-library/src/lib/data/shared/base.response";

@Injectable({ providedIn: 'root' })
export class UpdateLocationGroupByIdUsecase implements UseCase<RenameLocationGroup,BaseResponse<string>> {

  constructor(private readonly locationGroupRepository: LocationGroupRepository) {
  }

  execute(UpdateLocationGroupByIdRequest:RenameLocationGroup): Observable<BaseResponse<string>> {
    return this.locationGroupRepository.UpdateLocationGroupNameById(UpdateLocationGroupByIdRequest);
  }

}
